module.exports = __webpack_public_path__ + "img/logo-site-pbt.a856134d.png";